import type { Todo } from 'owa-todo-types';
import { TodoListItem, TodoListItemCallbacks } from 'owa-todo-list-item';
import { getIsEditingTodo } from '../selectors/agendaStoreTodoViewSelectors';
import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { getTodoScenarioActions } from '../actions/getTodoScenarioActions';
import { getScenarioActions } from '../actions/getScenarioActions';
import popoutReadingPane from 'owa-popout/lib/utils/popout/popoutReadingPane';

import styles from './AgendaTodoListItem.scss';

export interface AgendaTodoListItemProps {
    scenarioId: string;
    todo: Todo;
}

export const AgendaTodoListItem = observer(function AgendaTodoListItem(
    props: AgendaTodoListItemProps
) {
    const { scenarioId, todo } = props;
    const {
        markTodoImportant,
        removeTodoImportance,
        updateTodoSubject,
        markTodoComplete,
        markTodoIncomplete,
    } = getTodoScenarioActions(scenarioId, 'Item');
    const {
        updateTodoCurrentEditingId,
        clickAgendaTodo,
        rightClickAgendaTodo,
    } = getScenarioActions(scenarioId);
    const todoCallbacks: TodoListItemCallbacks = {
        clickEmail: clickEmail,
        markTodoComplete: markTodoComplete,
        markTodoIncomplete: markTodoIncomplete,
        star: markTodoImportant,
        unstar: removeTodoImportance,
        updateTodoSubject: updateTodoSubject,
        showTodoContextMenu: rightClickAgendaTodo,
        clickTodo: clickAgendaTodo,
        updateIsEditing: updateTodoCurrentEditingId,
    };
    const isEditingTodo = getIsEditingTodo(scenarioId);

    return (
        <TodoListItem
            isBeingEdited={isEditingTodo}
            key={todo.Id}
            todo={todo}
            callbacks={todoCallbacks}
            todoClassName={styles.todo}
            showTodoListItemInfo={false}
        />
    );
});

function clickEmail(emailId: string) {
    popoutReadingPane('mail', emailId);
}
